import styled from '@emotion/styled'

export const HeadingLabel = styled.div<{ isNested: boolean }>`
  padding-left: ${({ isNested }) => (isNested ? 'var(--lumen-padding-16)' : '0')};
`
